import { Component, Inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { UtilityService } from 'src/app/services/utility.service';
import { AssetService } from '../../services/asset.service';
import { DeleteConfirmModalComponent } from 'src/app/commons/delete-confirm-modal/delete-confirm-modal.component';
import { ActivatedRoute } from '@angular/router';
import { NewFileModalComponent } from 'src/app/files/new-file-modal/new-file-modal.component';
import * as _ from 'lodash';

@Component({
  selector: 'app-add-asset',
  templateUrl: './add-asset.component.html',
  styleUrls: ['./add-asset.component.scss']
})
export class AddAssetComponent implements OnInit {

  assetForm: FormGroup
  vehicleAssetForm: FormGroup
  loading
  assetTypeId: any;
  modelTitle: string;
  error
  isDelete = false
  isExtraFiled
  isDisplay: boolean = false
  isView: boolean = false
  files: any = [];
  newFiles: any = []
  _isVehicleFields = false

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<any>,
    private _utilityService: UtilityService,
    public _assetService: AssetService,
    public _cd: ChangeDetectorRef
  ) { }

  ngOnInit() {
    console.log("data of assets", this.data);

    if (this.data.id == '007' || this.data.id == '008' || this.data.id == '006' || this.data.id == '002') {
      this.isExtraFiled = false
      // this.isDisplay = false
      $(".field-width").addClass("col-sm-6");
    } else {
      this.isExtraFiled = true
      // this.isDisplay = true
      $(".field-width").addClass("col-sm-6");
    }


    if (this.data.id == '006') this.isDisplay = true
    else if (this.data.id == '007' || this.data.id == '008') this.isDisplay = false
    else this.isDisplay = true

    if (this.data.id == '009' || this.data.id == '010') this.isView = true
    else this.isView = false

    this.assetTypeId = this.data.assetTypeId
    if (this.data && this.data.edit) {
      this.modelTitle = 'Edit Asset'
      this.createForm(this.data.formData)
      if (this.data.formData.files && this.data.formData.files.length) this.files = this.data.formData.files
    } else {
      this.modelTitle = 'Add Asset'
      this.createForm()
    }

    if (this.data.id && this.data.id === '009') {
      this._isVehicleFields = true;
      this.createVehicleExtraFieldForm(this.data.formData)
    }

  }

  // FORM GROUP


  createForm(data?) {
    console.log("WHAT IS THE DATA OF FORM", data);

    this.assetForm = new FormGroup({
      title: new FormControl((data && data.title) ? data.title : '', Validators.required),
      assetTypeId: new FormControl(this.assetTypeId),
      uniqueId: new FormControl((data && data.uniqueId) ? data.uniqueId : '', Validators.required),
      serialNo: new FormControl((data && data.serialNo) ? data.serialNo : ''),
      servieDate: new FormControl((data && data.servieDate) ? data.servieDate : ''),
      vehicleReg: new FormControl((data && data.details && data.details && data.details.vehicleReg) ? data.details.vehicleReg : ''),
      expiryDate: new FormControl((data && data.details && data.details.expiryDate) ? data.details.expiryDate : ''),
      inspectionDate: new FormControl((data && data.details && data.inspectionDate) ? data.inspectionDate : ''),
      linkedAsset: new FormControl((data && data.linkedAsset) ? data.linkedAsset : ''),
      otherCategoryLink: new FormControl((data && data.otherCategoryLink) ? data.otherCategoryLink : [])
    })

    console.log("VALUE OF FORM", this.assetForm.value);

  }


  createVehicleExtraFieldForm(data?) {

    this.vehicleAssetForm = new FormGroup({
      registrationNumber: new FormControl((data && data.details && data.details && data.details.registrationNumber) ? data.details.registrationNumber : ''),
      manufacture: new FormControl((data && data.details && data.details && data.details.manufacture) ? data.details.manufacture : ''),
      model: new FormControl((data && data.details && data.details && data.details.model) ? data.details.model : ''),
      colour: new FormControl((data && data.details && data.details && data.details.colour) ? data.details.colour : ''),
      purchase: new FormControl((data && data.details && data.details && data.details.purchase) ? data.details.purchase : ''),
      VINNumber: new FormControl((data && data.details && data.details && data.details.VINNumber) ? data.details.VINNumber : ''),
      V5RefNumber: new FormControl((data && data.details && data.details && data.details.V5RefNumber) ? data.details.V5RefNumber : ''),
      leaseCompany: new FormControl((data && data.details && data.details && data.details.leaseCompany) ? data.details.leaseCompany : ''),
      aggrementNumber: new FormControl((data && data.details && data.details && data.details.aggrementNumber) ? data.details.aggrementNumber : ''),
      leaseCost: new FormControl((data && data.details && data.details && data.details.leaseCost) ? data.details.leaseCost : ''),
      totalPayable: new FormControl((data && data.details && data.details && data.details.totalPayable) ? data.details.totalPayable : ''),
      leaseStartDate: new FormControl((data && data.details && data.details && data.details.leaseStartDate) ? data.details.leaseStartDate : ''),
      leaseDuration: new FormControl((data && data.details && data.details && data.details.leaseDuration) ? data.details.leaseDuration : ''),
      leaseEndDate: new FormControl((data && data.details && data.details && data.details.leaseEndDate) ? data.details.leaseEndDate : ''),
      currentMileage: new FormControl((data && data.details && data.details && data.details.currentMileage) ? data.details.currentMileage : ''),
      mileageOnLease: new FormControl((data && data.details && data.details && data.details.mileageOnLease) ? data.details.mileageOnLease : ''),
      mileageRemaining: new FormControl({ value: (data && data.details && data.details && data.details.mileageRemaining) ? data.details.mileageRemaining : '', disabled: true }),
      insurance: new FormControl((data && data.details && data.details && data.details.insurance) ? data.details.insurance : ''),
      taxedUntilDate: new FormControl((data && data.details && data.details && data.details.taxedUntilDate) ? data.details.taxedUntilDate : ''),
      motUntilDate: new FormControl((data && data.details && data.details && data.details.motUntilDate) ? data.details.motUntilDate : ''),
      nextServiceDate: new FormControl((data && data.details && data.details && data.details.nextServiceDate) ? data.details.nextServiceDate : ''),
    })
  }


  // UTILITY


  onChangeEvent(value, formcontrol) {
    console.log("formcontrol value", formcontrol);

    // this.assetForm.patchValue({ servieDate: value })
    this.assetForm.controls[formcontrol].setValue(value)

    console.log("after set the value in asset", this.assetForm.value);


  }

  compareObjects(o1: any, o2: any): boolean {
    // console.log("compareObjects called", o1, o2)
    return o1._id === o2._id;
  }
  compareSingleObject(o1: any, o2: any): boolean {
    // console.log("compareObjects called", o1, o2)
    return o1._id === o2._id;
  }

  addFileModal() {


    let obj = {
      isAsset: true,
    }

    // if (this.materialId != undefined) {
    let addedCourse = this._utilityService.commonDialogBoxOpen(NewFileModalComponent, obj).afterClosed().subscribe((fileQueue) => {
      console.log("The queue recieved is", fileQueue);
      // if (fileQueue == undefined || fileQueue.length == 0) return;

      _.forEach(fileQueue, (file) => {
        if (this.data && this.data.edit == true) file['isnew'] = true; this.newFiles.push(file)
        // console.log("new file-->", this.newFiles);
        this.files.push(file);
        console.log("file-->", this.files);
      })
      console.log("after new files added", this.newFiles);


    });
  }



  deletedFile(event, currentIndex) {
    console.log("When file is deleted", event);

    //  this.files.splice(event._id, 0)
    this.files = this.files.filter((x, index) => index != currentIndex)
    if (this.newFiles && this.newFiles.length) {
      let element = this.newFiles.findIndex((x) => x.Location == event.Location)
      console.log("Deleted element from new files", element);
      if (element > -1) this.newFiles = this.newFiles.filter((x, index) => index != element)
    }
    console.log("after file is removed", this.files, this.newFiles);

  }


  // Blur Event when asset title added
  blurAssetTitleEvent(event) {
    console.log("THIS IS EVENT", event, this.assetForm.value.uniqueId)
    if (this.assetForm.value.uniqueId == "" && this.assetForm.value.title !== "") {
      let element = this.data.assetUniqueId.split('-')
      const temp = this.assetForm.value.title.split(' ').map(function (item) { return item[0] }).join('').toUpperCase();
      console.log("ELEMENT DATA", element, temp);
      let uniqueId = element[0] + '-' + temp + '-' + element[1]
      this.assetForm.patchValue({
        uniqueId: uniqueId
      })
    }
  }

  calculateMilage() {
    const formData = this.vehicleAssetForm.value
    if (formData.currentMileage && formData.mileageOnLease) {
      console.log("VEHICLE FORM DATA", this.vehicleAssetForm.value)
      let remainingAmount = formData.mileageOnLease - formData.currentMileage
      console.log("remaining amount", remainingAmount);
      this.vehicleAssetForm.patchValue({
        mileageRemaining: remainingAmount
      })
    }
  }

  onVehicleChangeEvent(value, formcontrol) {
    console.log("formcontrol value", formcontrol);
    this.vehicleAssetForm.controls[formcontrol].setValue(value)
    console.log("after set the value in asset", this.vehicleAssetForm.value);
  }

  // API CALL

  addTitle() {
    this.loading = true
    console.log("add asset title form values--->", this.assetForm.value)
    console.log("form-data=========>", this.data.formData);
    if (this.assetForm.valid) {
      let data = this.assetForm.value
      data['files'] = this.files
      data['categoryId'] = this.data.id
      if (this.data && this.data.edit) {
        data['assetId'] = this.data.formData._id
        if (this.newFiles && this.newFiles.length) {
          data['newFiles'] = this.newFiles;
          data.files = data.files.filter((x) => x._id)
        }
        console.log("ASSET MODEL DATA", this.data)
        if (data.linkedAsset && data.linkedAsset.length) {
          data.linkedAsset = data.linkedAsset.filter((x) => {
            x['linkedType'] = 'asset'
            return x
          })
        }
        // if(this.data.formData.linkedAsset && this.data.formData.linkedAsset.length) {
        data['jobAssets'] = this.data.formData.linkedAsset.filter((x) => x.linkedType == 'labourjob')
        if (this._isVehicleFields) {
          data['details'] = this.vehicleAssetForm.getRawValue()
        }
        // }
        console.log("This is final obj to send", data);
        this._assetService.editAsset(data).subscribe((response) => {
          console.log("resposne of edit", response);
          this._utilityService.closeDialog(this.dialogRef, response)
          this.loading = false
        }, err => {
          console.log("error", err);
          this.error = err.msg
          this.loading = false
        })
      } else {
        console.log("this data response return data", this.assetForm.value, this.files)
        console.log("DATA OF SUBMIT ASSET", data)
        if (data.linkedAsset && data.linkedAsset.length) {
          data.linkedAsset = data.linkedAsset.filter((x) => {
            x['linkedType'] = 'asset'
            return x
          })
        }
        if (this._isVehicleFields) {
          data['details'] = this.vehicleAssetForm.getRawValue()
        }
        this._assetService.createNewAsset(data).subscribe((res) => {
          console.log("response of new assest added", res);
          this._utilityService.closeDialog(this.dialogRef, res)
          this.loading = false
        }, err => {
          console.log("error", err);
          this.error = err.msg
          this.loading = false
        })
      }
    }
    else {
      console.log("LOG OF ASSET FORM", this.assetForm);

      this.assetForm.markAllAsTouched()
      this._cd.detectChanges()
      // this.error = "Title is required!"
      // this._utilityService.closeDialog(this.dialogRef)
      this.loading = false;
    }
  }



  delete() {
    // let obj = {
    //   assetId: this.data.formData._id,
    // }
    console.log(this.data.formData._id, "this.data.formData._id");
    let assetId = this.data.formData._id
    const dialogRef = this._utilityService.commonDialogBoxOpen(DeleteConfirmModalComponent, "Asset")
      .afterClosed().subscribe((data) => {
        if (data == '') return
        else if (data == 'yes') {
          this.loading = true
          this._assetService.deleteAsset(assetId)
            .subscribe((data) => {
              data['isDeleted'] = true
              console.log('Hello response data here ==>', data)
              this._utilityService.closeDialog(this.dialogRef, data)
              this.loading = false;
            }, (error) => {
              console.log('delete asset some error occure!!!', error)
            })
        }
      })
  }

}
